import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import { getAccessToken, getUserType } from "../hooks/useLocalStorage";
import { Url } from "../Api/Api";

const SimulationContext = createContext();

export const SimulationProvider = ({ children }) => {
  const token = getAccessToken();
  const userType = getUserType();
  const [pastData, setPastData] = useState([]);
  const [isLoader, setIsLoading] = useState(false);

  const [liveData, setLiveData] = useState([]);
  const [isActiveLoader, setIsActiveLoader] = useState(false);

  const [allAdminDetailsData, setAdminDetailsData] = useState([]);
  const [allAdminLoading, setAllAdminLoading] = useState(false);

  const [studentRoleData, setStudentRoleData] = useState(null);

  const [isCategoryCompleted, setIsCategoryCompleted] = useState(() => {
    const stored = localStorage.getItem("selectedCategory");
    if (stored && stored !== "null" && stored !== "") return true;
    const completed = localStorage.getItem("categoryCompleted");
    if (completed === "true") return true;
    // Return null so drawer doesn't flash-disable on refresh
    return false;
  });


  /* -------------------- API FUNCTIONS -------------------- */

  const Get_Simulation_Data = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${Url.ActiveSimulation}/completed`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPastData(response?.data || []);
    } catch (error) {
      console.error("Error fetching completed simulations", error);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  const Get_ActiveSimulation_Data = useCallback(async () => {
    try {
      setIsActiveLoader(true);
      const response = await axios.get(`${Url.ActiveSimulation}/Active`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLiveData(response?.data?.simulations || []);
    } catch (error) {
      console.error("Error fetching active simulations", error);
    } finally {
      setIsActiveLoader(false);
    }
  }, [token]);

  const fetch_AllAdmin_Data = useCallback(async () => {
    try {
      setAllAdminLoading(true);
      const response = await axios.get(Url.Get_All_Admin, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdminDetailsData(response?.data || []);
    } catch (error) {
      console.error("Error fetching admin data", error);
    } finally {
      setAllAdminLoading(false);
    }
  }, [token]);

  /* -------------------- INITIAL API CALL (STRICT MODE SAFE) -------------------- */

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    // if (!token || hasFetchedRef.current) return;

    // hasFetchedRef.current = true;

    if (userType === "admin") {
      Get_ActiveSimulation_Data();
      Get_Simulation_Data();
    }
  }, []);

  /* -------------------- LOCAL STORAGE SYNC -------------------- */

  // useEffect(() => {
  //   localStorage.setItem(
  //     "categoryCompleted",
  //     JSON.stringify(isCategoryCompleted)
  //   );
  // }, [isCategoryCompleted]);
//   useEffect(() => {
//   const storedCategory = localStorage.getItem("selectedCategory");
//   const completed = localStorage.getItem("categoryCompleted");

//   if (
//     (storedCategory && storedCategory !== "null" && storedCategory !== "") ||
//     completed === "true"
//   ) {
//     setIsCategoryCompleted(true);
//   } else {
//     setIsCategoryCompleted(false);
//   }
// }, []);
useEffect(() => {
  const stored = localStorage.getItem("selectedCategory");

  if (stored && stored !== "null" && stored !== "") {
    setIsCategoryCompleted(true);
  } else {
    setIsCategoryCompleted(false);
  }
}, []);
  /* -------------------- CONTEXT VALUE -------------------- */

  const value = useMemo(
    () => ({
      pastData,
      isLoader,
      Get_Simulation_Data,

      liveData,
      isActiveLoader,
      Get_ActiveSimulation_Data,

      allAdminDetailsData,
      allAdminLoading,
      fetch_AllAdmin_Data,

      isCategoryCompleted,
      setIsCategoryCompleted,
    

      studentRoleData,
      setStudentRoleData,
    }),
    [studentRoleData, isCategoryCompleted, setIsCategoryCompleted, liveData]
  );

  return (
    <SimulationContext.Provider value={value}>
      {children}
    </SimulationContext.Provider>
  );
};

/* -------------------- CUSTOM HOOK -------------------- */

export const useSimulation = () => useContext(SimulationContext);
